import {
  ComponentWithAs,
  mergeStyles,
  Provider,
  ProviderProps,
  teamsTheme,
} from "@fluentui/react-northstar";

import { fluentProviderStyles } from "./FluentProvider.styles";

export const FluentProvider: ComponentWithAs<
  keyof JSX.IntrinsicElements,
  ProviderProps
> = ({ styles, ...rest }: ProviderProps) => (
  <Provider
    theme={teamsTheme}
    styles={mergeStyles(styles ?? {}, fluentProviderStyles)}
    {...rest}
  />
);
